const surveysFromDashboard = (list = []) => {
  // surveysFromDashboard currently used by survey dashboard which is a legacy graphql endpoint
  // don't mix it with surveyFrom
  const surveyList = list.map((survey) => ({
    // original fields
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    id: survey.id,
    // @ts-expect-error TS(2339): Property 'surveyName' does not exist on type 'neve... Remove this comment to see the full error message
    surveyName: survey.surveyName,
    // @ts-expect-error TS(2339): Property 'created' does not exist on type 'never'.
    created: survey.created,
    // @ts-expect-error TS(2339): Property 'endTimeUTC' does not exist on type 'neve... Remove this comment to see the full error message
    endTimeUTC: survey.endTimeUTC,
    // @ts-expect-error TS(2339): Property 'hashCode' does not exist on type 'never'... Remove this comment to see the full error message
    hashCode: survey.hashCode,
    // @ts-expect-error TS(2339): Property 'responseRate' does not exist on type 'ne... Remove this comment to see the full error message
    responseRate: survey.responseRate,
    // @ts-expect-error TS(2339): Property 'startTimeUTC' does not exist on type 'ne... Remove this comment to see the full error message
    startTimeUTC: survey.startTimeUTC,
    // @ts-expect-error TS(2339): Property 'statusId' does not exist on type 'never'... Remove this comment to see the full error message
    statusId: survey.statusId,
    // @ts-expect-error TS(2339): Property 'timezoneName' does not exist on type 'ne... Remove this comment to see the full error message
    timezoneName: survey.timezoneName,
    // @ts-expect-error TS(2339): Property 'typeId' does not exist on type 'never'.
    typeId: survey.typeId,
    // @ts-expect-error TS(2339): Property 'totalCount' does not exist on type 'neve... Remove this comment to see the full error message
    totalCount: survey.totalCount,
    // @ts-expect-error TS(2339): Property 'completedCount' does not exist on type '... Remove this comment to see the full error message
    completedCount: survey.completedCount,
    // @ts-expect-error TS(2339): Property 'remindersCount' does not exist on type '... Remove this comment to see the full error message
    remindersCount: survey.remindersCount,

    // new custom fields
    startDate: '',
    endDate: '',

    // legacy custom fields
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    surveyId: survey.id,
    // @ts-expect-error TS(2339): Property 'typeId' does not exist on type 'never'.
    surveyTypeId: survey.typeId,
    surveyStartAt: '',
    surveyEndAt: '',
    // @ts-expect-error TS(2339): Property 'created' does not exist on type 'never'.
    surveyCreateAt: Number(survey.created),
    surveyResponseRate: '',
    surveyResponseRatioDisplay: '',
    disableEmailSending: !!survey.disableEmailSending,
    isContinuous: survey.isContinuous,
  }));

  return surveyList;
};

export { surveysFromDashboard };
